"use client"
import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import dayjs from "dayjs";
import { convertSecondsToTime } from "@/helpers/time";
import StripedProgressComponent from "./StripedProgressComponent";

const NoticeComponent = ({
    raffle
}) => {
    const timer = useRef(null);
    let interval = useRef(null);
    const [startDate, setStartDate] = useState(dayjs(raffle?.notice_start_date));
    const [endDate, setEndDate] = useState(dayjs(raffle?.notice_end_date));
    const [percentage, setPercentage] = useState(0);
    const [totalSeconds, setTotalSeconds] = useState(0);

    const convertDatesDiffIntoSeconds = (datePast, dateFuture) => {
        return dayjs(dateFuture).diff(dayjs(datePast), 'seconds');
    }

    function calculateRemainingTime() {
        let tempTotalSeconds = convertDatesDiffIntoSeconds(startDate, endDate);
        let currentSeconds = convertDatesDiffIntoSeconds(dayjs(), endDate);

        setPercentage(currentSeconds * 100 / tempTotalSeconds);
        setTotalSeconds(tempTotalSeconds);

        timer.current = currentSeconds;
    }

    function calculatePercentage(propTime) {
        return 100 - (propTime * 100 / totalSeconds);
    }

    useEffect(() => {
        if (!startDate || !endDate) {
            return;
        }
        calculateRemainingTime();
        interval.current = setInterval(() => {
            calculateRemainingTime();
        }, 1000);
    }, [startDate, endDate]);

    useEffect(() => {
        if (timer.current <= 0) {
            clearInterval(interval.current);
        }
    }, [timer.current])

    return (
        <Box sx={{ mb: 2, pb: 2, background: "linear-gradient(90deg, rgba(162,56,58,1) 0%, rgba(226,90,140,1) 100%);", borderRadius: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-evenly" }}>
                <img src="/fire.gif" width={45} />
                <Typography color={"white"} fontWeight={700} sx={{ textAlign: "center", fontSize: "0.75rem" }}>{raffle?.notice_message}</Typography>
                <img src="/fire.gif" width={45} />
            </Box>
            <Box sx={{ width: "100%", }}>
                <Box sx={{ mx: 2 }}>
                    <StripedProgressComponent
                        value={timer.current <= 0 ? 100 : calculatePercentage(timer.current)}
                        variant="determinate"
                        color="error"
                        sx={{ height: 30, width: 500, borderColor: "black", borderWidth: 10 }}
                    />
                </Box>
                <div style={{ marginTop: -27, position: "relative", textAlign: "center", backgroundColor: "rgba(0,0,0,0)", width: "100%", height: 30 }}>
                    <span style={{ fontSize: 14, color: "rgba(255,255,255,.7)", fontWeight: 700 }}>{timer.current > 0 ? <>Encerra em {convertSecondsToTime(timer.current)}</> : <>Encerrado!</>}</span>
                </div>
                <Typography sx={{ textAlign: "center", color: "white", fontSize: 15, fontWeight: 500 }}>{raffle?.notice_second_message}</Typography>
                {
                    (startDate.isValid() && endDate.isValid()) &&
                    <Typography sx={{ textAlign: "center", color: "white", fontSize: 12 }}>
                        Válido de {dayjs(startDate).format("DD/MM/YYYY")} ás {dayjs(startDate).format("HH:mm")}
                        &nbsp;até&nbsp;
                        {dayjs(endDate).format("DD/MM/YYYY")} ás {dayjs(endDate).format("HH:mm")}
                    </Typography>
                }

            </Box>
        </Box>
    );
};

export default NoticeComponent;